<template>
    <div class="form">
        <ValidationObserver ref="form">

            <PreviousOrnaWorkExp
                :user="user"
                :variants-list="how_hear"
                @data-changed="updateForm"
            ></PreviousOrnaWorkExp>

            <div class="row">
                <div class="col-12 text-right ">
                    <div class="wrap-border-top">
                        <div class="btns-wrap">
                            <a href="/application-step-4"
                               class="btn btn--outline-primary w-100 w-sm-auto">Back</a>
                            <a href="javascript:void(0)" @click="save" class="btn btn--secondary w-100 w-sm-auto">Continue</a>
                        </div>

                    </div>
                </div>
            </div>
        </ValidationObserver>

    </div>
</template>

<script>

import VueMultiSelect from "../../../../../../resources/js/plugins/VueMultiSelect.vue";
import PreviousOrnaWorkExp from "../CommonForms/PreviousOrnaWorkExp.vue";
import ApplicationFormService from "../services/ApplicationFormService";


export default {
    props: {
        user: {
            type: Object,
            required: true
        },
        how_hear: {
            type: Array,
            required: true
        },
    },
    components: {
        PreviousOrnaWorkExp,
        VueMultiSelect
    },
    name: "ApplicantFormStep5",

    data() {
        return {
            dataFormStep5: {}
        }
    },
    methods: {
        save() {
            (async () => {
                const valid = await this.$refs.form.validate();

                if (!valid) {
                    this.$showValidationErrorMessage()
                    return;
                }
                try {
                    const response = await ApplicationFormService.saveStep5(this.dataFormStep5);
                    if (response.status === 200) {
                        this.$showSuccessMessage();
                        setTimeout(() => {
                            window.location.href = '/application-step-6';
                        }, 1000)
                    }
                } catch (error) {
                    this.$handleErrors(error)
                }
            })();
        },
        updateForm(dataPrevOrnaWorkExp) {
            this.dataFormStep5 = dataPrevOrnaWorkExp;
        },
    },
    mounted() {
        this.dataFormStep5 = this.user.work_experience
    }


}

</script>

<style scoped>

</style>
